export const emptyBlock = (block?: Partial<any>): any => ({
  id: 0,
  ...block
});
